import eventBus from "@sd-utility/eventbus";

const getEventHandler = (event?: string) => {
  return () => {
    if (!event) return;

    if (event.startsWith("modal/")) {
      eventBus.publish("modal/open", event);
    } else if (event.startsWith("quiz/")) {
      eventBus.publish("quiz/open", event);
    } else {
      return null;
    }
  };
};

export default getEventHandler;
